module.exports = __webpack_public_path__ + "static/img/UTM教室_2.d5dd067.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTM/UTM教室_2.png
// module id = 2AtP
// module chunks = 0